<loader-overlay-component [show]="isloading"></loader-overlay-component>
<div class="mainBody">
    <div class="dmv-search-results inner-home">
        <div class="container">
            <div class="row no-margin">
                <div class="col-6 col-sm-2 mt-4 ">
                 
                            </div>


                <div class="col-12 col-sm-8 mt-4">
                    <div id="searchResu">{{isEnrollCancel? 'Enrollment Cancelled': 'Keep My Enrollment' }}</div>
                    <p id="addthereco">&nbsp;</p>
                </div>
                <div class="col-6 col-sm-2 icon-cart mt-4">

                </div>



                <div class="col-12 col-sm-8 col-md-6  m-auto" role="alert" *ngIf="errorMessage">
                    <div class="alert alert-danger homeError">   
                        {{errorMessage}}
                    </div>
                 </div>

                <div class="container mt-2 mb-5 p-5 bg-light">
                    <div class="flex flex-column flex-md-row mb-5 align-items-center">
                        <div>
                            <img [ngStyle]="{'width':(dmvStoreService.cancellationTokengData$ | async)?.agencySealWidth+'px'}"
                                src="{{globalService.externalResourcesUrl}}{{(dmvStoreService.cancellationTokengData$ | async)?.agencySealFileName}}"
                                class="img-fluid">
                        </div>
                        <div class="p-4">
                            <img src="{{globalService.staticResourceURL}}assets/images/Icon-logo-color.svg"
                                class="img-fluid" style="margin-top: 8px; width:200px" aria-label="myeasygov logo">
                        </div>
                    </div>
                    <div class="bodyTextStyle" [innerHTML]="cancellationData?.text"></div>

                </div>





            </div>

            <div class="container m-auto text-center flex flex-column flex-md-row justify-content-center" *ngIf="!cancellationToken">
              
                    <div  class="p-2">
                <a><button class="btn btn-primary  btn-continue m-auto" (click)="continue()">Continue</button></a>
                        </div>

            </div>
        </div>
    </div>
</div>